import { Component, type ErrorInfo, type ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    console.error("Varnax failed to render", error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="global-error" role="alert">
        <section className="global-error-card">
          <span className="global-error-mark" aria-hidden="true"><i /></span>
          <p>ARENA CONNECTION LOST</p>
          <h1>The arena fell silent.</h1>
          <span>Your progress is safe. Reload the client to return to the fight.</span>
          <button type="button" onClick={() => window.location.reload()}>RELOAD ARENA</button>
        </section>
      </main>
    );
  }
}
